<template>
    <el-card>
        <template slot='header'>
        <div>
            <span>财务开票信息</span>
        </div>
        </template>
        <ly-information 
            :config="infoConfig"
            :data="info"
            class="mt15"
            v-if="type == 'show'">        
        </ly-information>
        <Ly-search-form 
            :config="formConfig" 
            :rules="formRules"
            :is-search="false"
            label-width="120px"
            ref="searchForm"
            v-else>
        </Ly-search-form>
    </el-card>
</template>
<script>
    import LySearchForm from '@c/search-form'
    import LyInformation from '@c/information'
    /**
     * 财务开票操作
     * @time 2018-03-19
     * @author zjs
     */
    export default {
        props: {
            userInfo: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            infoId: [String, Number], // 发票登记的ID
            info: {
                type: Object,
                default: function () {
                    return {}
                }
            }, // 显示的数据
            type: {
                type: String,
                default: 'show'
            } // 显示类型［show：显示，update: 操作］
        },
        components: {
            LySearchForm,
            LyInformation
        },
        data () {
            return {
                formConfig: [{
                    name: "财务开票类型",
                    type: "text",
                    field: "finance_invoice_type",
                    default: ""
                }, {                   
                    name: "开票日期",
                    type: "text",
                    field: "finance_work_time",
                    default: ""
                }, {
                    name: "发票号码",
                    type: "text",
                    field: "finance_no",
                    default: ""
                }, {
                    name: "实际开票金额",
                    type: "text",
                    field: "finance_amount",
                    default: ""
                }, {
                    name: "财务开票人",
                    type: "text",
                    field: "caiwukpr",
                    default: ""
                }, {
                    name: "发票领取人",
                    type: "LyAutoSelect",
                    field: "received_name",
                    json: {
                        api: 'api/employeelist'
                    },
                    default: ''
                }, {
                    name: "发票代收税金",
                    type: "text",
                    field: "finance_tax",
                    default: ""
                }, {
                    name: "备注",
                    type: "text",
                    field: "finance_zhaiyao",
                    json: {
                        span: 8
                    },
                    default: ""
                }, {
                    name: "发票领取备注",
                    type: "text",
                    field: "invoice_get_zhaiyao",
                    json: {
                        span: 8
                    },
                    default: ""
                }], // 表单信息配置
                formRules: {
                    'received_name': [{ required: true, trigger: 'blur' }]
                },
                // 显示信息的配置
                infoConfig: [
                    {"label":"财务开票类型","prop":"finance_invoice_type"},
                    {"label":"开票日期","prop":"finance_work_time"},
                    {"label":"发票号码","prop":"finance_no"},
                    {"label":"实际开票金额","prop":"finance_amount"},
                    {"label":"财务开票人","prop":"caiwukpr"},
                    {"label":"发票领取人","prop":"received_name"},
                    {"label":"发票代收税金","prop":"finance_tax"},
                    {"label":"备注","prop":"finance_zhaiyao"},
                    {"label":"发票领取备注","prop":"invoice_get_zhaiyao"}
                ],
                submitForm: {
                    id: 0
                }
            }
        },
        mounted () {
            this.submitForm.id = this.infoId
            if (this.type === 'edit') {
                this.$refs['searchForm'].initBindFormData(this.info)
            }
            // 2018.8.22 39批B 发票领取人默认填充  update wxq
            if (this.userInfo && this.userInfo.name) {
                this.$refs['searchForm'].initBindFormData({
                    received_name: this.userInfo.name
                })
            }
        },
        methods: {
            /**
             * 外部调用的数据提交
             */
            submit (callback) {
                if (this.$refs['searchForm'].validateForm()) {
                    // 获得得查询的字段
                    this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                    this.$api.query('api/invoicedealinfo', this.submitForm).then(() => {
                        callback && callback()
                    }).catch((error) => {
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            },
        }
    }
</script>